import React from 'react';
import PropTypes from 'prop-types';
import usePaginatedCollectionState from 'Hooks/usePaginatedCollectionState';

const PaginatedCollectionStateContext = React.createContext(undefined);

const PaginatedCollectionStateProvider = ({
  children,
  link,
}) => {
  const {
    loading,
    loadingError,
    collection,
    refreshCollection,
    setCollection,
    hasNextPage,
    hasPrevPage,
    getNextPage,
    getPrevPage,
  } = usePaginatedCollectionState({
    link,
  });

  const memoizedValue = React.useMemo(() => {
    return {
      loading,
      loadingError,
      collection,
      refreshCollection,
      setCollection,
      hasNextPage,
      hasPrevPage,
      getNextPage,
      getPrevPage,
    };
  }, [
    loading,
    loadingError,
    collection,
    refreshCollection,
    setCollection,
    hasNextPage,
    hasPrevPage,
    getNextPage,
    getPrevPage,
  ]);

  return (
    <PaginatedCollectionStateContext.Provider value={memoizedValue}>
      {children}
    </PaginatedCollectionStateContext.Provider>
  );
};

// Use PaginatedCollectionState State Context
const usePaginatedCollectionStateContext = () => {
  const context = React.useContext(PaginatedCollectionStateContext);
  if (context === undefined) {
    throw new Error('usePaginatedCollectionStateContext must be used within a PaginatedCollectionStateProvider');
  }
  return context;
};

PaginatedCollectionStateProvider.propTypes = {
  link: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export {
  PaginatedCollectionStateProvider,
  usePaginatedCollectionStateContext,
};
